export default "__VITE_ASSET__BHYTUOFH__"